import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Button from '@atlaskit/button/standard-button';
export default function Page(props) {
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    appearance: "subtle"
  }));
}